module.exports = __webpack_public_path__ + "img/batch-directive.181bc6d6.svg";